export const unsubscribeFromChannelMutation = `
      mutation UnsubscribeFromChannel($channelId: ID!) {
        unsubscribeFromChannel(id: $channelId)
      }
    `;
